import axios from 'axios';
const token = localStorage.getItem('user-token');

export default {
  async getRcvatQuotation(quotationId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation/${quotationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getRcvatQuotationDatails(quotationId, insuranceId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation/${quotationId}/vehicles?insuranceId=${insuranceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async createRcvatQuotation(quotation) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation`,
        quotation,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async updateRcvatQuotation(quotation) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation/${quotation.quotationId}`,
        quotation,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async calculate(params) {
    try {
      const queryString = this.construirQueryString(params);
      const response = await axios.get(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/vehicles/calculate?${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async createEndorsement(quotationId, endorsement) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation/${quotationId}/endorsements`,
        endorsement,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async uploadVehicles(quotationId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation/${quotationId}/vehicles`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getEndorsementTypes() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/endorsements-types`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getEndorsementHistory(quotationId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/quotation/${quotationId}/endorsements`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  construirQueryString(objeto, prefixo) {
    const partes = [];

    for (let chave in objeto) {
      if (objeto.hasOwnProperty(chave)) {
        const valor = objeto[chave];
        const chaveComposta = prefixo ? `${prefixo}[${chave}]` : chave;

        if (valor !== null && typeof valor === 'object') {
          partes.push(this.construirQueryString(valor, chaveComposta));
        } else {
          partes.push(
            `${encodeURIComponent(chaveComposta)}=${encodeURIComponent(valor)}`,
          );
        }
      }
    }

    return partes.join('&');
  },
};
